'use client'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { login, logout } from '@/services/authService'
import { LoginCredentials, AuthResponse } from '@/types/UserType'
import {
  setAccessToken,
  removeAccessToken,
  setUserInStorage,
  removeUserFromStorage,
} from '@/services/storage'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/providers/auth-provider'

export function useLoginMutation() {
  const queryClient = useQueryClient()
  const router = useRouter()
  const { setAuthUser } = useAuth()

  return useMutation<AuthResponse, unknown, LoginCredentials>({
    mutationFn: login,
    onSuccess: (data) => {
      setAccessToken(data.token)
      setUserInStorage(data.admin)
      setAuthUser(data.admin)
      queryClient.setQueryData(['user'], data.admin)
      router.push('/dashboard')
    },
  })
}

export function useLogoutMutation() {
  const queryClient = useQueryClient()
  const router = useRouter()
  const { clearAuth } = useAuth()

  return useMutation<void, unknown, void>({
    mutationFn: logout,
    onSettled: () => {
      removeAccessToken()
      removeUserFromStorage()
      clearAuth()
      queryClient.removeQueries({ queryKey: ['user'], exact: true })
      router.push('/login')
    },
  })
}
